import { useMutation } from '@tanstack/react-query';
import download from 'downloadjs';
import { useIntl } from 'react-intl';
import { BillingStatsPayload } from '@rossum/api-client/billing';
import { useApiClient } from '../../../lib/apiClient';
import { notify } from '../../toaster';
import { BillingEntity, getBillingEndpoint } from './useBillingEntity';

const QUERY_KEY_BILLING_STATS_EXPORT = 'billing-stats-export';

export const useBillingStatsExport = () => {
  const api = useApiClient();
  const intl = useIntl();
  return useMutation({
    mutationKey: [QUERY_KEY_BILLING_STATS_EXPORT] as const,

    mutationFn: async ({
      billingEntity,
      payload,
    }: {
      billingEntity: BillingEntity;
      payload: BillingStatsPayload;
    }) => {
      const { id, endpoint } = getBillingEndpoint(billingEntity);
      return api.request(endpoint.billingStats.export(id, payload));
    },
    onSuccess: data => {
      download(
        data,
        `${QUERY_KEY_BILLING_STATS_EXPORT}-${Date.now()}.csv`,
        'text/csv'
      );
    },
    onError: () => {
      notify.error({
        title: intl.formatMessage({
          id: 'containers.billing.usage.export.error',
        }),
      });
    },
  });
};
